var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "rounded",
          attrs: { data: _vm.data, align: "center", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Cód. Protheus", width: "120", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.codigo_protheus))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Descrição", "min-width": "220", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.descricao))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Criado em", width: "180", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(scope.row.created_at, true))
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Atualizado em", width: "180", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(scope.row.updated_at, true))
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            {
              attrs: { fixed: "right", align: "right", width: "50" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom-end",
                                trigger: "hover"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "mini",
                                    type: "info",
                                    plain: "",
                                    circle: "",
                                    disabled: _vm.loading
                                  },
                                  slot: "reference"
                                },
                                [_c("i", { staticClass: "el-icon-more" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  style: {
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                    gap: "4px",
                                    maxWidth: "300px"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { style: { width: "100%" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          style: { width: "100%" },
                                          attrs: {
                                            slot: "reference",
                                            size: "mini",
                                            type: "warning",
                                            plain: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.dispatchPrazoPagamento(
                                                scope.row.id
                                              )
                                            }
                                          },
                                          slot: "reference"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit"
                                          }),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Editar")])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticStyle: { width: "100%" },
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_c("i", { staticClass: "el-icon-menu" })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "empty" },
            [
              _c("el-empty", {
                attrs: { description: "Nenhum prazo de pagamento disponível" }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt-3" },
        [
          _c(
            "el-col",
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.data.currentPage,
                  "page-sizes": _vm.pagination.pageSizes,
                  "page-size": _vm.pagination.data.perPage,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.pagination.total
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("PrazoPagamentoEdit", {
        ref: "prazoPagamentoEdit",
        on: { updated: _vm.fetch }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53c55e9f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c55e9f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/prazo_pagamento/PrazoPagamentoList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-53c55e9f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/prazo_pagamento/PrazoPagamentoList.vue
// module chunks = 2